import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";

import { 
    useropen, listsetting1, listsetting2, listsetting3, seltypeorcategory,
    listsetting1_2, listsetting2_2, listsetting3_2,
    listsetting1_3, listsetting2_3, listsetting3_3,

} from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import moment from 'moment';

import * as APIS from "../../utils/service";
export default function Login({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [inputArr, setinputArr] = useState([]);   
    const [mb_id, setmb_id] = useState('');   
    const [mb_pass, setmb_pass] = useState('');   
    const [errmsg, seterrmsg] = useState(['', '']);   
    const { listset1, listset2, listset3, listset1_2, listset2_2, listset3_2, listset1_3, listset2_3, listset3_3 } = useSelector(state => state.userInfo);


    const savelist1 = [
        {selltypeCker: [1,2,3], sellstatus: true, key: 'status', viewernames: '상태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'productcode', viewernames: '매물번호', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'create_dt', viewernames: '등록일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'update_dt', viewernames: '확인일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'mediation', viewernames: '공동중개', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'category_2name', viewernames: '매물종류', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'sigungu', viewernames: '시군구', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'dong', viewernames: '법정동', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'jibun', viewernames: '지번', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'title', viewernames: '건물(단지)명', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_dong', viewernames: '해당동', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_dong_floor_all', viewernames: '해당동 총층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_floor', viewernames: '해당층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_unit', viewernames: '호수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'area_supply', viewernames: '공급(타입)', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'area_private', viewernames: '전용면적', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_room', viewernames: '방/욕실수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'sell_type', viewernames: '거래형태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'price_sell', viewernames: '가격', disabled: true},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_all', viewernames: '현 보증금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_month', viewernames: '현 월세', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'revenue', viewernames: '수익률', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'realinvest', viewernames: '실 투자금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'pypricetype1', viewernames: '평당가(공급)', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'price_maintenance', viewernames: '관리비', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_households', viewernames: '세대수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car_all', viewernames: '총 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car', viewernames: '세대당 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_direction', viewernames: '방향', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_elevator', viewernames: '승강기', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'client_hp', viewernames: '연락처', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'user', viewernames: '담당자', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'matching', viewernames: '매칭', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_usage', viewernames: '용도', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_date', viewernames: '건축물일자', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'desc', viewernames: '비고', disabled: false},        
    ];
    const savelist2 = [
        {selltypeCker: [1,2,3], sellstatus: true, key: 'status', viewernames: '상태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'productcode', viewernames: '매물번호', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'create_dt', viewernames: '등록일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'update_dt', viewernames: '확인일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'mediation', viewernames: '공동중개', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'category_2name', viewernames: '매물종류', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'sigungu', viewernames: '시군구', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'dong', viewernames: '법정동', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'jibun', viewernames: '지번', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'title', viewernames: '건물명', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_dong', viewernames: '해당동', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_dong_floor_all', viewernames: '해당동 총층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_floor', viewernames: '해당층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_unit', viewernames: '호수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'area_contract', viewernames: '계약면적', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'area_private', viewernames: '전용면적', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_room', viewernames: '방/욕실수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'sell_type', viewernames: '거래형태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'price_sell', viewernames: '가격', disabled: true},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_all', viewernames: '현 보증금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_month', viewernames: '현 월세', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'revenue', viewernames: '수익률', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'realinvest', viewernames: '실 투자금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'pypricetype2', viewernames: '평당가(전용)', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'price_keymoney', viewernames: '권리금', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'price_maintenance', viewernames: '관리비', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car_all', viewernames: '총 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car', viewernames: '세대당 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_direction', viewernames: '방향', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_elevator', viewernames: '승강기', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'client_hp', viewernames: '연락처', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'user', viewernames: '담당자', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'matching', viewernames: '매칭', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_usage', viewernames: '용도', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_date', viewernames: '건축물일자', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'desc', viewernames: '비고', disabled: false},               
    ];
    const savelist3 = [
        {selltypeCker: [1,2,3], sellstatus: true, key: 'status', viewernames: '상태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'productcode', viewernames: '매물번호', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'create_dt', viewernames: '등록일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'update_dt', viewernames: '확인일', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'mediation', viewernames: '공동중개', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'category_2name', viewernames: '매물종류', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'sigungu', viewernames: '시군구', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'dong', viewernames: '법정동', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'jibun', viewernames: '지번', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'title', viewernames: '건물명', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_floor_under_all', viewernames: '지하 총층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_floor_all', viewernames: '지상 총층', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_unit_all', viewernames: '총 호수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'building_unit_empty', viewernames: '공실수', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: '?????', viewernames: '공실률', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'area_land', viewernames: '토지면적', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'area_floor', viewernames: '연면적', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'sell_type', viewernames: '거래형태', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'price_sell', viewernames: '가격', disabled: true},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_all', viewernames: '현 보증금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'now_price_month', viewernames: '현 월세', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'revenue', viewernames: '수익률', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'realinvest', viewernames: '실 투자금', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'pypricetype3', viewernames: '평당가(토지)', disabled: false},
        {selltypeCker: [1], sellstatus: false, key: 'pypricetype4', viewernames: '평당가(건물)', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'price_maintenance', viewernames: '관리비', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car_all', viewernames: '총 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_car', viewernames: '세대당 주차', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_direction', viewernames: '방향', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_elevator', viewernames: '승강기', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'client_hp', viewernames: '연락처', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'user', viewernames: '담당자', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: true, key: 'matching', viewernames: '매칭', disabled: true},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'item_date', viewernames: '건축물일자', disabled: false},
        {selltypeCker: [1,2,3], sellstatus: false, key: 'desc', viewernames: '비고', disabled: false},               
    ];

    useEffect(() => {
        seterrmsg(errmsg?.map(( xe, ie ) => ''));
    }, [mb_id, mb_pass]);


    const loginSubmit = () => {

        dispatch(loadingflas({ loading: true }));
        //navigate('/Storeselctor');
        let sender = {
            id: mb_id,
            pw: mb_pass,
        }


        console.log("?????????", sender);
        APIS.postData('/v1/login/login', sender).then(({ data }) => {
            console.log(data);
            if(data){
                localStorage.setItem("token", data);

                let memberinfos = {};
                APIS.postData('/v1/auth/info').then(({ data }) => {
                    const { compony, application, name, selData } = data;
                    console.log(data);
                    
                    dispatch(
                        useropen({
                            userdata: {login: true}
                        })
                    );   
                    
                    try {
                        dispatch(listsetting1({listset1: JSON.parse(selData?.sel_list1)}));     
                        dispatch(listsetting2({listset2: JSON.parse(selData?.sel_list2)}));     
                        dispatch(listsetting3({listset3: JSON.parse(selData?.sel_list3)}));     
                        dispatch(listsetting1_2({listset1_2: JSON.parse(selData?.sel_list1_2)}));     
                        dispatch(listsetting2_2({listset2_2: JSON.parse(selData?.sel_list2_2)}));     
                        dispatch(listsetting3_2({listset3_2: JSON.parse(selData?.sel_list3_2)}));     
                        dispatch(listsetting1_3({listset1_3: JSON.parse(selData?.sel_list1_3)}));     
                        dispatch(listsetting2_3({listset2_3: JSON.parse(selData?.sel_list2_3)}));     
                        dispatch(listsetting3_3({listset3_3: JSON.parse(selData?.sel_list3_3)}));     
                        dispatch(
                            seltypeorcategory({
                                seltypes: selData?.type,
                                category_1s: selData?.category
                            })
                        );
                    } catch (error) {
                        if(
                            !listset1 || listset1?.length === 0 || !listset2 || listset2?.length === 0 || !listset3 || listset3?.length === 0 ||
                            !listset1_2 || listset1_2?.length === 0 || !listset2_2 || listset2_2?.length === 0 || !listset3_2 || listset3_2?.length === 0 ||
                            !listset1_3 || listset1_3?.length === 0 || !listset2_3 || listset2_3?.length === 0 || !listset3_3 || listset3_3?.length === 0
                        ){
                            dispatch(listsetting1({listset1: savelist1}));     
                            dispatch(listsetting2({listset2: savelist2}));     
                            dispatch(listsetting3({listset3: savelist3}));     
                            dispatch(listsetting1_2({listset1_2: savelist1}));     
                            dispatch(listsetting2_2({listset2_2: savelist2}));     
                            dispatch(listsetting3_2({listset3_2: savelist3}));     
                            dispatch(listsetting1_3({listset1_3: savelist1}));     
                            dispatch(listsetting2_3({listset2_3: savelist2}));     
                            dispatch(listsetting3_3({listset3_3: savelist3}));     
                            dispatch(
                                seltypeorcategory({
                                    seltypes: 1,
                                    category_1s: 1
                                })
                            );
                        }
                    }
                    console.log("?????????", data);

                    if(data?.access_token){
                        let sender = {}
                        dispatch(loadingflas({ loading: true }));
                        APIS.postData('/v1/schedule/colors', sender).then(({ data }) => {
                            if(data){
                                localStorage.setItem('logintime', moment().format('YYYY-MM-DD HH:mm:ss'));
                                navigate("/Main");
                            }
                        }).catch(({ response }) => {
                            const { data } = response;
                            console.log(response);
                        }).finally(() => {
                            dispatch(loadingflas({ loading: false }));
                        });  
                    } else {
                        localStorage.setItem('logintime', moment().format('YYYY-MM-DD HH:mm:ss'));
                        navigate("/Main");
                    }

                    

                    // if(application){
                    //     if(compony){
                    //         dispatch(
                    //             useropen({
                    //                 userdata: {login: true}
                    //             })
                    //         );   
                    //         navigate("/Main");
                    //     } else {
                    //         if(application?.status*1 === 1){
                    //             seterrmsg(errmsg?.map(( xe, ie ) => ie === 1 ? '가입심사중인 회원입니다.' : xe));
                    //             return;
                    //         } else if(application?.status*1 === 99){
                    //             navigate("/StoretypeFinsub");
                    //         }
                    //     }

                    // } else {
                    //     if(compony?.status*1 === 1){
                    //         seterrmsg(errmsg?.map(( xe, ie ) => ie === 1 ? '가입심사중인 회원입니다.' : xe));
                    //         return;
                    //     } else if(compony?.status*1 === 99){
                    //         navigate("/StoretypeFin");
                    //     } else {
                    //         if(!compony){
                    //             navigate("/Storetype2Write", {state: {registerName: name}});
                    //             return;
                    //         }
                    //         dispatch(
                    //             useropen({
                    //                 userdata: {login: true}
                    //             })
                    //         );   
                    //         navigate("/Main");
                    //     }
                    // }

                }).catch((e) => {
                    console.log(e);
                }).finally(() => {
                }); 	


            }
        }).catch(({ response }) => {
            const { data } = response;
            if(data?.code === 0){
                seterrmsg(errmsg?.map(( xe, ie ) => ie === 1 ? data?.msg : xe));
            }
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });   
    }
    const loginSubmitCker = () => {
        if(mb_id === ''){
            seterrmsg(errmsg?.map(( xe, ie ) => ie === 0 ? '아이디를 입력해주세요.' : xe));
            return;
        }
        if(mb_pass === ''){
            seterrmsg(errmsg?.map(( xe, ie ) => ie === 1 ? '비밀번호를 입력해주세요.' : xe));
            return;
        }
        seterrmsg(errmsg?.map(( xe, ie ) => ''));
        let sender = {
            email: mb_id
        }
        APIS.postData('/v1/login/emailCheck', sender).then(({ data }) => {
            console.log(data);
            if(data){
                seterrmsg(errmsg?.map(( xe, ie ) => ie === 0 ? '가입된 이메일주소가 아닙니다.' : ''));
            }
        }).catch(({ response }) => {
            const { data } = response;
            loginSubmit();
        }).finally(() => {
            //dispatch(loadingflas({ loading: false }));
        });
    }


    useEffect(() => {
        const script = document.createElement('script');
        const callBackFunc = document.createTextNode(
            "function result(result) {" +
                "try {" +
                    "result = JSON.parse(result);" +
                    "window.location.href='/Register?name='+result?.data+'&phone='+result?.phone+'&gender='+result?.gender+'';" +
                "} catch (error) {" +
                "}" +
            "}");
        script.appendChild(callBackFunc);
        document.body.appendChild(script);
    }, []);
    const mok_popup = () => {
        window.MOBILEOK.process("https://api.maemul.net/mok_std_request", "WB", "result");
    }

    return(
        <Layout header={false}>
            <div className='normalform'>
                <div className='normalform_title'>로그인</div>
                <div className='inputArea'>
                    <Input 
                        className={`inputs`}
                        placeholder="이메일(ID)"
                        setValue={setmb_id}
                        value={mb_id}
                        name="searchvar"
                        label={mb_id !== '' && '이메일(ID)'}
                        labelstyle={1}
                        error={errmsg[0]}
                        clearflag={true}
                        submitfunc={() => {
                            loginSubmitCker();
                        }}
                    />                    
                </div>                        
                <div className='inputArea'>
                    <Input 
                        className={`inputs`}
                        type={'password'}
                        placeholder="비밀번호"
                        setValue={setmb_pass}
                        value={mb_pass}
                        name="searchvar"
                        label={mb_id !== '' && '비밀번호'}
                        labelstyle={1}
                        error={errmsg[1]}
                        passwordview={true}
                        submitfunc={() => {
                            loginSubmitCker();
                        }}                        
                    />                    
                </div>     
                <div className='loginbutton'>
                    <Button
                        onPress={() => {
                            loginSubmitCker();
                        }}                    
                        buttonTxt={'로그인'}
                    />
                </div>     
               
                <div className='findidpwarea'>
                    <Button
                        buttonTxt={'아이디 찾기'}
                        className={'findbutton'}
                        onPress={() => {
                            navigate('/Findid');
                        }}
                    />
                    <span></span>
                    <Button
                        buttonTxt={'비밀번호 찾기'}
                        className={'findbutton'}
                        onPress={() => {
                            navigate('/Findpw');
                        }}                        
                    />
                </div>     

                <div className='registerbuttonArea'>
                    <p>계정이 없으세요?</p>
                    <Button
                        buttonTxt={'회원가입'}
                        className={'linenormalbutton'}
                        onPress={() => {
                            // dispatch(
                            //     open({
                            //         component: `모두의 매물 이용을 위해 본인 인증이 필요합니다.\n모두의매물은 1인 1계정만 이용이 가능합니다.`,
                            //         title: '회원가입',
                            //         titleviewer: true,
                            //         alert: false,
                            //         button: "본인인증",
                            //         onPress: () => {
                            //             mok_popup();
                            //             dispatch(close());
                            //         }
                            //     })
                            // ); 
                            // navigate('/JoinHelp');
                            navigate('/Register0');
                        }}                             
                    />
                </div>     

            </div>
        </Layout>
    )
}

